<template>
  <SectionContainer>
    <ContainerMedium>
      <PrimaryTitle class="mb-2">Validação de Certificado</PrimaryTitle>

      <PrimaryParagraph>Para validar a autenticidade de um certificado CyberClass, preencha o campo abaixo.</PrimaryParagraph>

      <AlertBox
        v-if="isCertificateValid === true"
        class="mt-4"
      >
        <strong>CERTIFICADO #{{ certificate.id }} <u>VÁLIDO</u></strong>
        <div class="mt-2">
          Emitido em nome de: <strong>{{ certificate.member_name }}</strong>
          <br />
          Data da emissão: <strong>{{ certificate.created_at | toDateFormat('D [de] MMMM, Y') }}</strong>
        </div>
      </AlertBox>

      <AlertBox
        v-if="isCertificateValid === false"
        class="mt-4"
        type="danger"
      >
        <strong>CERTIFICADO <u>NÃO ENCONTRADO</u></strong>
        <div class="mt-2">
          Não encontramos a emissão desse certificado. Em caso de dúvida, <router-link :to="{name: 'support'}">clique aqui</router-link> para entrar em contato com nossa equipe.
        </div>
      </AlertBox>

      <form
        class="mt-4"
        @submit.prevent="fetchCertificate"
      >
        <PrimaryInput
          placeholder="Número do certificado: 0001"
          type="tel"
          mask="########"
          v-model="certificateId"
          :disabled="isLoading"
          :focus="true"
        />

        <div class="d-flex align-items-center">
          <PrimaryButton
            type="submit"
            :disabled="!certificateId || isLoading"
          >Verificar</PrimaryButton>

          <LoadingIcon
            v-if="isLoading"
            class="ml-3"
          />
        </div>
      </form>
    </ContainerMedium>
  </SectionContainer>
</template>

<script>
  import PrimaryInput from '@/components/form/PrimaryInput'
  import PrimaryButton from '@/components/buttons/PrimaryButton'
  import PrimaryTitle from '@/components/text/titles/PrimaryTitle'
  import SectionContainer from '@/components/layout/SectionContainer'
  import ContainerMedium from '@/components/layout/containers/ContainerMedium'
  import PrimaryParagraph from '@/components/text/paragraphs/PrimaryParagraph'
  import AlertBox from '@/components/layout/AlertBox'
  import { getCertificate } from '@/api/course.api'
  import LoadingIcon from '@/components/layout/LoadingIcon'

  export default {
    components: {
      AlertBox,
      LoadingIcon,
      PrimaryTitle,
      PrimaryInput,
      PrimaryButton,
      ContainerMedium,
      SectionContainer, 
      PrimaryParagraph,
    },

    metaInfo () {
      return {
        title: 'Validação de Certificado | CyberClass'
      }
    },

    data: () => ({
      isLoading: false,
      certificateId: null,
      certificate: {},
      isCertificateValid: null
    }),

    methods: {
      async fetchCertificate () {
        this.isCertificateValid = null
        this.isLoading = true

        try {
          this.certificate = await getCertificate(parseInt(this.certificateId))
          this.isCertificateValid = true
        } catch (err) {
          this.isCertificateValid = false
        }

        this.isLoading = false
      },
    }
  }
</script>
